import turf from '@turf/turf';
import { get, isEmpty, isNil, split } from 'lodash';

import * as videoOps from '../../api/Videos/video-operations';

const DEFAULT_LINE_ARRAY = [
  [-180, -90],
  [-180, 90],
  [180, 90],
  [180, -90]
];
const DEFAULT_MAP_BOUNDS = [0, 0, 0, 0];

/**
 * Checks the projected video position to display it or not.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.currentFeature - The feature to get the projected coordinates.
 * @param {boolean} arg.isMapShown - Flag to check is map is being shown in the visualizer.
 * @param {object} arg.leafletMap - The Leaflet map.
 * @param {object} arg.video - The video object.
 * @returns {boolean} True if video should be shown.
 */
const showProjectedVideo = ({ currentFeature, isMapShown, leafletMap, video }) => {
  const mapBBox =
    isNil(leafletMap) || isEmpty(leafletMap)
      ? DEFAULT_MAP_BOUNDS
      : split(leafletMap.getBounds().toBBoxString(), ',');

  const mapBoundingRect = turf.bboxPolygon(mapBBox);
  const videoBoundingRect = turf.lineToPolygon(
    turf.lineString(get(currentFeature, 'properties.coordinates', DEFAULT_LINE_ARRAY))
  );

  const isVideoInsideMap = turf.booleanContains(mapBoundingRect, videoBoundingRect);

  const showVideo = videoOps.isProjectedVideo(video) && isMapShown && isVideoInsideMap;

  return showVideo;
};

export default showProjectedVideo;
